import axios from "axios";
import { partnerBase } from "../base";

/* Candidate test-taking API (public, session-token + email OTP).
   Runs against the partner API host (same backend the portal uses).
   Post-OTP steps carry the access token in the X-Assessment-Token header. */

const base = partnerBase;
const url = (sessionId, path = "") => `${base}/api/public/assessment/${sessionId}${path}`;
// Device token identifies the browser tab holding the single-active-session
// lock; carried on every authed call alongside the access token.
const authed = (token, deviceToken) => ({
  headers: { "X-Assessment-Token": token, ...(deviceToken ? { "X-Device-Token": deviceToken } : {}) },
});

export const loadAssessment = (sessionId) =>
  axios.get(url(sessionId)).then((r) => r.data);

export const submitIdentity = (sessionId, data) =>
  axios.post(url(sessionId, "/identity"), data).then((r) => r.data);

export const verifyAssessmentOtp = (sessionId, code) =>
  axios.post(url(sessionId, "/verify-otp"), { code }).then((r) => r.data);

export const assessmentConsent = (sessionId, token) =>
  axios.post(url(sessionId, "/consent"), {}, authed(token)).then((r) => r.data);

export const startAssessment = (sessionId, token, deviceToken) =>
  axios.post(url(sessionId, "/start"), {}, authed(token, deviceToken)).then((r) => r.data);

// Resume support: what's already answered + true remaining time, for a
// refreshed/reopened tab to rejoin an in-progress attempt.
export const getAssessmentStatus = (sessionId, token) =>
  axios.get(url(sessionId, "/status"), authed(token)).then((r) => r.data);

export const assessmentHeartbeat = (sessionId, token, deviceToken) =>
  axios.post(url(sessionId, "/heartbeat"), {}, authed(token, deviceToken)).then((r) => r.data);

export const saveAssessmentAnswer = (sessionId, token, deviceToken, questionId, response, integrity, timeMs) =>
  axios
    .post(url(sessionId, "/answer"), { questionId, response, integrity, timeMs }, authed(token, deviceToken))
    .then((r) => r.data);

export const submitAssessment = (sessionId, token, deviceToken, answers, integrity) =>
  axios.post(url(sessionId, "/submit"), { answers, integrity }, authed(token, deviceToken)).then((r) => r.data);

export const saveAssessmentPhoto = (sessionId, token, deviceToken, photo) =>
  axios.post(url(sessionId, "/photo"), { photo }, authed(token, deviceToken)).then((r) => r.data);

// Shared enrollment links
export const getEnrollInfo = (token) =>
  axios.get(`${base}/api/public/assessment/enroll/${token}`).then((r) => r.data);
export const startEnroll = (token, data) =>
  axios.post(`${base}/api/public/assessment/enroll/${token}/start`, data).then((r) => r.data);
